/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { MessageBox, ParsedText, PortalSpinner, useGlobalLang } from '@veeam-vspc/shared/components';

import type { VspcLang } from 'configs/languages';

import { useTransportRequest } from 'views/hooks';
import { getFailureMessage } from './utils';

import type { FailureMessageParams } from './interfaces';

export interface FailureMessageDialogProps {
    header?: string;
    deactivate: () => void;
    iconSrc: string;
    url: string;
    paramsForFailureMessageRequest: Record<string, any>;
    paramsForFailureMessage: Omit<FailureMessageParams, 'failureMessage'>;
}

export const FailureMessageDialog: React.FC<FailureMessageDialogProps> = (props) => {
    const lang = useGlobalLang<VspcLang>();
    const {
        header = lang.JOB_STATUS,
        deactivate,
        iconSrc,
        url,
        paramsForFailureMessageRequest,
        paramsForFailureMessage,
    } = props;
    const { loading, data } = useTransportRequest<FailureMessageDialogProps['paramsForFailureMessageRequest'], string[]>(
        url,
        paramsForFailureMessageRequest,
    );

    return (
        <MessageBox
            header={header}
            onRequestClose={deactivate}
            actions={[
                { text: lang.OK, onClick: deactivate },
            ]}
            iconSrc={iconSrc}
        >
            <>
                {loading && <PortalSpinner whiteBg />}

                {!loading && (
                    <ParsedText
                        textOrConfig={getFailureMessage(lang, {
                            ...paramsForFailureMessage,
                            failureMessage: data as string[] ?? [],
                        })}
                    />
                )}
            </>
        </MessageBox>
    );
};
